document.addEventListener("DOMContentLoaded", () => {
	const passwordVisibilityButtons = document.querySelectorAll(".show-hide-password button.password-visibility");

	if (!passwordVisibilityButtons.length) {
		return;
	}

	passwordVisibilityButtons.forEach((button) => {
		const parent = button.closest(".show-hide-password");
		const passwordInput = parent.querySelector("input[type='password']");
		const icon = button.querySelector(".password-visibility-icon");

		button.addEventListener("click", (e) => {
			e.preventDefault();

			if (passwordInput.type === "password") {
				passwordInput.type = "text";
				icon.classList.remove("show");
				icon.classList.add("hide");
				button.setAttribute("aria-label", mswpt_vars.hide_pwd_label);
			} else {
				passwordInput.type = "password";
				icon.classList.remove("hide");
				icon.classList.add("show");
				button.setAttribute("aria-label", mswpt_vars.show_pwd_label);
			}
		});
	});
});
